import {apiClient} from './ApiClient';

export const executeBasicAuthenticationService = (token) => 
    apiClient.get(`/basicauth`, {
        headers: {
            Authorization: token
        }
    });

export const executeJwtAuthenticationService = (username, password) => 
    apiClient.post(`/rest/login`, {
        username, 
        password
    });

export const executeForgotPasswordService = (email) => 
    apiClient.post(`/rest/forgot-password`, {
        loginColumns: {
            userPass: [{
                name: "passEmail",
                val: email
            }]
        }
    });